import { createSlice } from "@reduxjs/toolkit";
import { saveProfileSettings } from "../actions/profileSettingsActions";

/**
 * Profile Settings (DATI PERSONALI)
 * - No autosave. Persist only when user taps "SALVA".
 */

const cleanText = (v) => {
  const s = String(v ?? "");
  const t = s.trim();
  // whitespace-only should be treated as empty
  return t ? s : "";
};

const trimOrEmpty = (v) => {
  const t = String(v ?? "").trim();
  return t ? t : "";
};

const initialState = {
  hydrated: false,
  form: {
    // profile privacy
    is_public_profile: false,

    // user fields
    name: "",
    surname: "",
    nickname: "",
    email: "",
    telephone: "",

    // master club subscriber fields
    sex: "", // "male" | "female"
    birth_date: "", // YYYY-MM-DD
    initial_weight: "",
    height: "",

    country_id: 1,
    country_text: "Italia",
    province_id: null,
    city_id: null,

    extras: {
      hobbies: [],
    },
  },
  save: {
    isLoading: false,
    success: false,
    error: "",
  },
};

const profileSettingsSlice = createSlice({
  name: "profileSettings",
  initialState,
  reducers: {
    hydrateFromUser: (state, action) => {
      const user = action.payload?.user || {};
      const sub = action.payload?.subscriber || {};

      state.form.name = trimOrEmpty(user?.name) || state.form.name;
      state.form.surname = trimOrEmpty(user?.surname) || state.form.surname;
      state.form.email = trimOrEmpty(user?.email) || state.form.email;
      state.form.telephone =
        trimOrEmpty(user?.telephone) || state.form.telephone;

      const nick = trimOrEmpty(sub?.nickname) || trimOrEmpty(user?.nickname);
      state.form.nickname = nick || state.form.nickname;

      const nickname = trimOrEmpty(sub?.nickname);
      state.form.nickname = nickname || state.form.nickname || state.form.nickname;

      state.form.is_public_profile = !!(
        sub?.is_public_profile ?? state.form.is_public_profile
      );

      state.form.sex = sub?.sex ?? state.form.sex;
      // normalize birth_date to YYYY-MM-DD when possible
      const bd = sub?.birth_date ?? "";
      const m = String(bd).match(/(\d{4})-(\d{2})-(\d{2})/);
      state.form.birth_date = m
        ? `${m[1]}-${m[2]}-${m[3]}`
        : bd || state.form.birth_date;

      state.form.initial_weight =
        sub?.initial_weight ?? state.form.initial_weight;
      state.form.height = sub?.height ?? state.form.height;

      state.form.country_id = sub?.country_id ?? state.form.country_id;
      state.form.country_text = sub?.country_text ?? state.form.country_text;

      state.form.province_id = sub?.province_id ?? state.form.province_id;
      state.form.city_id = sub?.city_id ?? state.form.city_id;

      const hobbies = sub?.extras?.hobbies ?? [];
      state.form.extras.hobbies = Array.isArray(hobbies)
        ? hobbies
        : hobbies
        ? [hobbies]
        : [];

      state.hydrated = true;
      state.save.success = false;
      state.save.error = "";
    },
    setProfileSettingsField: (state, action) => {
      const { key } = action.payload || {};
      let { value } = action.payload || {};
      if (!key) return;

      // ✅ normalize whitespace-only strings
      if (typeof value === "string" && value.trim() === "") value = "";

      if (key.startsWith("extras.")) {
        const k = key.replace("extras.", "");
        state.form.extras[k] = value;
        return;
      }

      state.form[key] = value;
    },

    resetSaveState: (state) => {
      state.save.success = false;
      state.save.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveProfileSettings.pending, (state) => {
        state.save.isLoading = true;
        state.save.success = false;
        state.save.error = "";
      })
      .addCase(saveProfileSettings.fulfilled, (state) => {
        state.save.isLoading = false;
        state.save.success = true;
      })
      .addCase(saveProfileSettings.rejected, (state, action) => {
        state.save.isLoading = false;
        state.save.success = false;
        state.save.error =
          action.payload || action.error?.message || "Errore salvataggio";
      });
  },
});

export const { hydrateFromUser, setProfileSettingsField, resetSaveState } =
  profileSettingsSlice.actions;

export default profileSettingsSlice.reducer;
